
import {Vue, Component} from 'vue-property-decorator';
import Template from "@/views/system-management/template/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import {forwardCompanyInvoicePass, queryForwardCompanyInvoiceAudit} from "@/api/booking-order";

@Component({name: 'ForwardCompanyInvoiceAudit',
  components: {Pagination, Template}
})
export default class ForwardCompanyInvoiceAudit extends Vue {
  private showDialog = false;
  private loading = false;
  private tableRenderKey = 0;
  private listReqSeq = 0;
  private params = {
    bookingOrderCode: '',
    audit: '未审核',
  }
  private page = {
    pageNumber: 1,
    pageSize: 20,
    total: 0,
  }
  private tableData = [];

  private onAuditChange() {
    this.page.pageNumber = 1;
    this.getList();
  }

  private async getList() {
    const seq = ++this.listReqSeq;
    this.loading = true;
    let audit = null;
    if (this.params.audit === '未审核') {
      audit = false;
    }
    if (this.params.audit === '已审核') {
      audit = true;
    }
    const params = {
      bookingOrderCode: this.params.bookingOrderCode,
      audit: audit,
      pageNumber: this.page.pageNumber,
      pageSize: this.page.pageSize,
    }
    try {
      const res = await queryForwardCompanyInvoiceAudit(params) as any;
      if (seq !== this.listReqSeq) return;
      this.tableData = res?.content ?? [];
      this.page.total = res?.total ?? 0;
      this.tableRenderKey += 1;
    } finally {
      if (seq === this.listReqSeq) this.loading = false;
    }
  }

  public openDialog() {
    this.getList();
    this.showDialog = true;
  }

  private async auditPass(row) {
    await forwardCompanyInvoicePass(row.id, { audit: true });
    this.$message({
      message: row.invoiceCode + '审核通过',
      type: 'success'
    });
    await this.getList();
  }

  private async cancelAudit(row) {
    await forwardCompanyInvoicePass(row.id, { audit: false });
    this.$message({
      message: row.invoiceCode + '取消审核',
      type: 'success'
    });
    await this.getList();
  }

  private close() {
    this.params = {
      bookingOrderCode: '',
      audit: '未审核',
    };
    this.tableRenderKey = 0;
    this.listReqSeq = 0;
    this.showDialog = false;
  }

}
